function FontModal() {
}

FontModal.events = {
    isInit: true,

    init: function() {
        var self = this;

        if (self.isInit) {
            $("#prolook-font-modal").on("click", ".font-item", self.onSelectFont);
            self.isInit = false;
        }
    },

    onSelectFont: function() {
        var code = $(this).data('application-code');
        var font_id = $(this).data('font-id');
        var applicationSettings = ub.funcs.getApplicationSettings(code);
        
        // Change Font Style
        FontModal.events.changeFont(applicationSettings, font_id);

        UIkit.modal("#prolook-font-modal").hide();
    },

    changeFont: function(application, font_id) {
        if (TextShapeCore.utilities.isTextShape(application.code)) {
            if (application.text_shape_type === "arc") {
                TextShapeCore.customControllers.changeTextArcFontStyle(application.code, false, font_id);
            }
            TextShapeCore.funcs.changeFont(application.code, false, font_id);
        } else {
            ub.funcs.changeFontFromPopup(font_id, application);
            ub.funcs.activateApplications(application.code);
            
            if (application.type === "front_number" || application.type === "back_number") {
                var _newFont = _.find(ub.data.fonts, {id: font_id}); 
                _.each (ub.current_material.settings.applications, function (_application) {
                    if (_application.type !== application.application_type && _application.type !== "logo" && _application.type !== "mascot") {
                        if (application.type.indexOf('number') !== -1 && _application.type.indexOf('number') !== -1) {
                            ub.funcs.changeFontFromPopup(font_id, _application);
                        }
                    } 
                });
            }

            var _matchingID = undefined;
            _matchingID = ub.data.matchingIDs.getMatchingID(application.code);

            if (typeof _matchingID !== "undefined") {
                var _matchingSettingsObject = _.find(ub.current_material.settings.applications, {code: _matchingID.toString()});
                if (typeof _matchingSettingsObject !== "undefined") {
                    ub.funcs.changeFontFromPopup(font_id, _matchingSettingsObject);
                }
            }
        }
    }
}

FontModal.funcs = {
    loadFontModal: function(text, application) {
        var fontObject = application.font_obj;
        var applicationType = typeof application.textLayoutType !== "undefined" ? application.textLayoutType : application.application_type;

        var fontData = [];
        var sampleSize = "2.0rem"

        if (ApplicationCore.utilities.isPlayerNumber(applicationType)) {
            sampleSize = "2.5rem";
        }

        var _one = 1; // flag
        if (window.ub.config.toString) { _one = "1"; }

        var enableFontRules = ub.funcs.enableFontRules(ub.config.brand, ub.user.id, ub.config.sport);

        // PL2.5 new feature
        // use new fonts configured by GA'S
        if (enableFontRules) {
                var newFonts = _.filter(ub.data.fonts, {is_new: _one});
                if (_.size(newFonts) > 0) {
                    ub.data.fonts = newFonts;
                }
        }

        _.each(ub.data.fonts, function(font) {
            fontData.push({
                id: font.id,
                name: font.name,
                caption: font.caption,
                sampleText: text,
                sampleSize: sampleSize
            });
        });

        var data = {
            code: application.code,
            application_type: applicationType.replace("_", " "),
            fonts: fontData,
        }

        var template = document.getElementById("m-prolook-font").innerHTML;
        var render = Mustache.render(template, data);

        $("#prolook-font-modal .prolook-font-main-container").html("");
        $("#prolook-font-modal .prolook-font-main-container").html(render);

        //hide font id from normal user
        if (!_.contains(ub.fontGuideIDs, ub.user.id)) {
            $('span.font-id').hide();
        }

        let blockPatternsRPOJersey = ['Perforated Football Jersey', 'RPO Jersey', 'RPO Pant'];
        if (_.contains(blockPatternsRPOJersey, ub.config.blockPattern)) {
            // Hide all divs first
            $("#prolook-font-modal .font-container > div").hide();
 
            // Show only divs containing the allowed font IDs for all applications
            $.each(ub.current_material.settings.applications, function(index, application) {
                $("#prolook-font-modal .font-container a.font-item").filter(function () {
                    return ['1811', '2284', '2299', '2280'].includes($(this).data("font-id").toString());
                }).closest('div').show();
            });
        }
 

        $("#prolook-font-modal .font-container a.uk-active").parent().removeClass("uk-disabled");
        $("#prolook-font-modal .font-container a.uk-active").removeClass("uk-active");

        $("#prolook-font-modal .font-container a[data-font-id='"+ fontObject.id +"']").parent().addClass("uk-disabled");
        $("#prolook-font-modal .font-container a[data-font-id='"+ fontObject.id +"']").addClass("uk-active");

        FontModal.events.init()

        UIkit.modal("#prolook-font-modal").show();
    }
}